








































import { Component, Vue } from 'vue-property-decorator';
import AuthActions from '../../store/actions/auth';

@Component({
  components: {
  },
})
export default class Login extends Vue {

   private username:string = '';
   private password:string = '';
   private errorMessage: string = '';

   constructor() {
       super();
   }

   login(){
       this.errorMessage = '';
       this.$store.dispatch(AuthActions.AUTH_REQUEST, { username: this.username, password: this.password }).then((response) => {
           this.$router.push('/');
       }).catch((error) => {
           this.errorMessage = 'The username or password you entered is invalid';
       });
   }

}
